import { ChangeDetectionStrategy, Component, Inject, inject, signal } from '@angular/core'
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatListModule } from '@angular/material/list'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { LayerIntegrationDialogData } from '@core/models/layers.model'
import { LayersClonedService } from '@core/services/layers-cloned.service'

@Component({
  selector: 'app-dialog-layer-integration',
  templateUrl: './dialog-layer-integration.component.html',
  styleUrl: './dialog-layer-integration.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    // Forms
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,

    // Material
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatListModule,
  ],
})
export class DialogLayerIntegrationComponent {
  readonly dialogRef = inject(MatDialogRef<DialogLayerIntegrationComponent>)
  private readonly _layersClonedService = inject(LayersClonedService)

  isLoading$ = signal<boolean>(false)

  layerIntegrationForm = new FormGroup({
    adminGeomTableName: new FormControl<string[]>([]),
    description: new FormControl<string>(''),
    style: new FormControl<string>(''),
  })

  constructor(@Inject(MAT_DIALOG_DATA) public data: LayerIntegrationDialogData) {
    if (this.data.layerType === 'Raster') {
      this.layerIntegrationForm
        .get('adminGeomTableName')
        ?.setValidators([Validators.required, Validators.minLength(1)])
    }
  }

  async submitFormLayerIntegration() {
    const repoName = this.data.repoName
    const layerType = this.data.layerType
    const adminGeomTableName = this.layerIntegrationForm.get('adminGeomTableName')?.value
    const description = this.layerIntegrationForm.get('description')?.value
    const style = this.layerIntegrationForm.get('style')?.value

    if (!this.layerIntegrationForm.valid) {
      return
    }

    if (
      this.data.layerType === 'Raster' &&
      (!adminGeomTableName || adminGeomTableName.length === 0)
    ) {
      return
    }

    this.isLoading$.set(true)
    try {
      await this._layersClonedService.integrateLayer(
        repoName,
        layerType,
        adminGeomTableName || [],
        description || '',
        style || '',
      )
      this.dialogRef.close(true)
    } finally {
      this.isLoading$.set(false)
    }
  }
}
